import { Loader, Breadcrumbs, cnMixSpace } from 'uikit';

import type React from 'react';
import { useMemo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

interface IProjectCreateProps {
    title: string;
    style?: React.CSSProperties;
    breadCrumbsItems?: any[];
    children?: React.ReactNode;
    isLoading?: boolean;
}

const h2Style = { margin: 0, padding: '20px 0' };

export const PageLayout = ({ title, style, breadCrumbsItems = [], children, isLoading }: IProjectCreateProps) => {
    const navigate = useNavigate();

    const pages = useMemo(
        () => [
            ...breadCrumbsItems,
            {
                label: title,
            },
        ],
        [breadCrumbsItems, title],
    );

    const handleBreadcrumbsItemClick = useCallback(
        ({ e, item }) => {
            e.preventDefault();
            navigate(item.href);
        },
        [navigate],
    );

    return isLoading ? (
        <Loader />
    ) : (
        <section className={cnMixSpace({ m: 'xl' })} style={style}>
            <Breadcrumbs items={pages} onItemClick={handleBreadcrumbsItemClick} size="xs" />
            <h2 style={h2Style}>{title}</h2>
            {children}
        </section>
    );
};

PageLayout.displayName = 'PageLayout';
